import React from 'react';
import { ArrowRight, Settings, MessageSquare } from 'lucide-react';

export const getFeatureAnnouncementConfig = () => [
  {
    alertId: "2025-08-dual-chat-v1",
    title: "What's New in Arrow",
    description: "We've been busy! Check out the latest features and improvements we've added to make your Arrow AI experience even better.",
    icon: ArrowRight,
    illustration: (
      <div className="absolute inset-0 bg-gradient-to-br from-violet-500 via-purple-500 to-indigo-500 opacity-90">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="relative">
            {/* Arrow logo/symbol */}
            <div className="text-4xl font-bold text-white/90 mb-2">Arrow AI</div>
            {/* Floating feature icons */}
            <div className="absolute -top-8 -left-8 text-white/60">
              <Settings size={20} />
            </div>
            <div className="absolute -top-4 right-0 text-white/60">
              <MessageSquare size={18} />
            </div>
            <div className="absolute -bottom-6 -right-4 text-white/60">
              <ArrowRight size={22} />
            </div>
            {/* Subtle glow effect */}
            <div className="absolute inset-0 bg-white/10 rounded-lg blur-xl"></div>
          </div>
        </div>
        <ArrowRight className="absolute top-4 left-4 text-white/80" size={24} />
      </div>
    ),
  },
  {
    alertId: "2025-08-dual-chat-v1",
    title: "Default Model",
    description: "You can now set a default model for new chats. This will be the model that is used for new chats unless you select a different model.",
    icon: Settings,
    illustration: (
      <div className="absolute inset-0 bg-gradient-to-br from-blue-500 via-indigo-500 to-purple-500 opacity-90">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="relative">
            {/* Central gear icon */}
            <div className="text-4xl text-white/90 mb-2 flex justify-center">
              <Settings size={48} className="animate-spin" style={{animationDuration: '8s'}} />
            </div>
            {/* Model selection indicators */}
            <div className="flex justify-center space-x-2">
              <div className="w-3 h-3 bg-white/60 rounded-full" />
              <div className="w-3 h-3 bg-white/90 rounded-full" />
              <div className="w-3 h-3 bg-white/40 rounded-full" />
            </div>
            {/* Floating settings symbols */}
            <div className="absolute -top-6 -left-6 text-white/50">
              <div className="w-2 h-2 bg-white/60 rounded-full" />
            </div>
            <div className="absolute -top-4 right-2 text-white/50">
              <div className="w-1.5 h-1.5 bg-white/50 rounded-full" />
            </div>
            <div className="absolute -bottom-4 -right-6 text-white/50">
              <div className="w-2.5 h-2.5 bg-white/70 rounded-full" />
            </div>
          </div>
        </div>
        <Settings className="absolute top-4 left-4 text-white/80" size={24} />
      </div>
    ),
  },
  {
    alertId: "2025-08-dual-chat-v1",
    title: "Dual Chats (beta)",
    description: "You can now chat with two models at once. This is useful for comparing the output of two different models.",
    icon: MessageSquare,
    illustration: (
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-500 via-teal-500 to-cyan-500 opacity-90">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="relative flex space-x-4">
            {/* Left chat bubble */}
            <div className="relative">
              <MessageSquare size={32} className="text-white/90" />
              <div className="absolute -top-2 -right-2 w-3 h-3 bg-white/70 rounded-full animate-pulse" />
            </div>
            {/* Connecting line */}
            <div className="flex items-center">
              <div className="w-8 h-0.5 bg-white/60" />
            </div>
            {/* Right chat bubble */}
            <div className="relative">
              <MessageSquare size={32} className="text-white/90" />
              <div className="absolute -top-2 -right-2 w-3 h-3 bg-white/70 rounded-full animate-pulse" style={{animationDelay: '0.5s'}} />
            </div>
            {/* Floating message indicators */}
            <div className="absolute -top-8 left-2 text-white/50">
              <div className="w-2 h-2 bg-white/60 rounded-full" />
            </div>
            <div className="absolute -bottom-6 right-4 text-white/50">
              <div className="w-1.5 h-1.5 bg-white/50 rounded-full" />
            </div>
          </div>
        </div>
        <MessageSquare className="absolute top-4 left-4 text-white/80" size={24} />
      </div>
    ),
  }
];